import { CreateFilterOptions, FilterRow, FilterType } from '@type/filter.type';

export class FilterDisplayOptions implements CreateFilterOptions {
  showCheckboxForEmptyValue = true;
  showCheckboxForFilledValueForFilters: FilterType[] = [];
  cacheDictionary = true;
  rows: CreateFilterOptions['rows'] = [];
  search: true | { searchFn?: () => FilterRow } = true;
}

export function createFilterOptions(options: Partial<FilterDisplayOptions>): FilterDisplayOptions {
  return Object.assign(new FilterDisplayOptions(), options);
}
